import { Link } from '@domain-group/suit-theme'

import useLoginAsUser from '@hooks/useLoginAsUser'

interface ActionProps {
  index: number,
  item: {
    href?: string,
    loginAsUserParams?: { redirect: string, userId: number },
    onClick: () => void,
    redirectUrl?: string,
    shouldUseLegacyLogin?: boolean,
    title?: string,
  },
  mobileStyle?: boolean,
}

const Action = (props: ActionProps) => {
  const { item, mobileStyle = false } = props

  const {
    href, loginAsUserParams, onClick, shouldUseLegacyLogin, title,
  } = item

  const { callbacks: { loginAsUser } } = useLoginAsUser(loginAsUserParams)

  return (
    <Link
      href={href}
      textProps={{
        fontSize: 'xsmall',
        marginLeft: !mobileStyle ? 'medium' : '',
      }}
      onClick={() => (shouldUseLegacyLogin ? loginAsUser() : onClick())}
    >
      {title}
    </Link>
  )
}

export default Action
